// extracted by mini-css-extract-plugin
export default {"field":"section_field__NM-Fa","fieldIcon":"section_fieldIcon__jzCrx","image":"section_image__eDbC2","fieldFixedText":"section_fieldFixedText__2GxE1"};